import React, { Fragment } from 'react'

import {
  CookiesSection,
  DisableBrowserCookies,
  ServiceChannelInfo,
} from './components'

import constants from 'constants/index'

const MenuContent = ({ selectedItem }) => {
  const { MENU_ITEMS_IDS } = constants.cookies.bannerTextOverride

  const COOKIE_MENU_CONTENT = {
    [MENU_ITEMS_IDS.COOKIES_MENU_ITEM_ID]: CookiesSection,
    [MENU_ITEMS_IDS.DISABLE_BROWSER_COOKIES_MENU_ITEM_ID]:
      DisableBrowserCookies,
    [MENU_ITEMS_IDS.SERVICE_CHANNEL_MENU_ITEM_ID]: ServiceChannelInfo,
  }

  const MenuContent = COOKIE_MENU_CONTENT[selectedItem] || Fragment

  return <MenuContent />
}

export default MenuContent
